export type { LemonTextAreaProps } from './LemonTextArea'
export { LemonTextArea } from './LemonTextArea'
